import React, { AriaAttributes, ReactNode } from "react";
import { cn } from "../../utils/cn";

export type HeaderSize = 1 | 2 | 3 | 4 | 5 | 6;
export interface HeadingProps extends AriaAttributes {
  children: ReactNode;
  className?: string;
  // TODO
  as?: string;
  sizeVariant?: HeaderSize;
}

const sizeMapping = [
  "font-medium leading-tight text-5xl mt-0",
  "font-medium leading-tight text-4xl mt-0",
  "font-medium leading-tight text-3xl mt-0",
  "font-medium leading-tight text-2xl mt-0",
  "font-medium leading-tight text-xl mt-0",
  "font-medium leading-tight text-base mt-0 ",
];

export function Header({
  sizeVariant,
  className,
  children,
  as,
  ...rest
}: HeadingProps) {
  sizeVariant = sizeVariant || 1;
  const sizeIndex = sizeVariant - 1;
  const Tag = (as || `h${sizeVariant}`) as keyof React.JSX.IntrinsicElements;
  return (
    <Tag className={cn(sizeMapping[sizeIndex], className)} {...rest}>
      {children}
    </Tag>
  );
}
